// Controlador de los botones +/- de cantidad en la CTA personalizada de buy-buttons.
// Antes vivía como onclick inline en el HTML. Extraído en mayo 2026.
//
// Marcado esperado:
//   <div class="arca-qty" data-quantity-wrapper data-arca-qty-step="1">
//     <button class="arca-qty__btn" data-arca-qty="decrement">−</button>
//     <input class="arca-qty__input" type="number" min="1" ...>
//     <button class="arca-qty__btn" data-arca-qty="increment">+</button>
//   </div>

(function () {
  function adjustQuantity(btn, direction) {
    var wrapper = btn.closest('.arca-qty');
    if (!wrapper) return;
    var input = wrapper.querySelector('.arca-qty__input');
    if (!input) return;

    var step = parseInt(wrapper.dataset.arcaQtyStep, 10);
    if (!step || step < 1) step = 1;

    var min = parseInt(input.min, 10);
    if (isNaN(min) || min < 1) min = 1;

    var current = parseInt(input.value || min, 10);
    if (isNaN(current)) current = min;

    var next;
    if (direction === 'increment') {
      next = current + step;
      var max = parseInt(input.max, 10);
      if (!isNaN(max) && max > 0 && next > max) next = max;
    } else {
      next = current - step;
      if (next < min) next = min;
    }

    if (next === current) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-arca-qty]');
    if (!btn) return;
    event.preventDefault();
    adjustQuantity(btn, btn.dataset.arcaQty);
  });
})();
